// removed by extract-text-webpack-plugin
module.exports = {"text800":"-J-9bNvQDiVAbc7QwbB3m","text700":"_1vYMhYBqApFR9XGQU0mKnU","text600":"ZpVDtLH1vwtVpMovxN3sZ","text500":"_1-NDbKfgao6AVOMNueHy5v","message":"_1K5gKeZtrwDO8f6aifn1il","text400":"_2t0gAKsqdhRi6qszoievCW","text300":"_1G3LV40nFsv-85zX-4cVeV","text200":"_1M77mlwbxjyVopftBlYWTj","textParagraph":"_2H9-cl0dsDJdVEDWnJW0Bv","crimp":"_9Jx_TqXrhmZxPZYdhBdxZ","trim":"_2XFfJ4esVWU7S2w9OpUHiu","flexCenter":"YJ4F3v9shrtLCHR8eWMbq","wrapper":"aPWiky3KxWHEPdWMp0BWT","hideTextOverflow":"_3MLyGNkNlGPuyKKS7w1DMQ","marginPageMainContent":"_1QFjXCwxRgta5caXNj5Xo4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/PageLoading/styles.scss
// module id = 581
// module chunks = 0